// extracted by mini-css-extract-plugin
export default {"manage_card":"ManageOsaRisk-module_manage_card_H30CwG"};